import { min } from "moment";

const medeString = str =>{
    let patt1 = /[0-9]/g;
    let result = str.match(patt1);
    if(result === null){
        return 0;
    }  
    return result.length;   
};

const noCaseSensitive = (filter, row) => {
    
    const id = filter.pivotId || filter.id;

    // if(row[id] !== null && filter.id.toLowerCase().indexOf("data") > -1){
    //     return (
    //         row[id] !== undefined ?
    //             FormataStringData(String(row[id].toLowerCase())).indexOf(filter.value.toLowerCase()) > -1 : true
    //     )
    // }
    // else 
    if (row[id] !== null && typeof row[id] === 'string') {
        return (
            row[id] !== undefined ?
                String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true
        )
    }
    else if (row[id] !== null && typeof row[id] === 'number') {
        if( (filter.value.toLowerCase() === "pendente de contato") && row[id] === 0 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "aguardando retorno") && row[id] === 1 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "agendado") && row[id] === 2 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "virou cliente") && row[id] === 3 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "não conciliado") && row[id] === 0 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "conciliado") && row[id] === 1 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "lançamento em duplicidade") && row[id] === 2 ){
            return true;
        }
        else if( (filter.value.toLowerCase() === "não consta venda") && row[id] === 3 ){
            return true;
        }
        else{
            return (
                row[id] !== undefined ?
                    String(row[id].toString().toLowerCase()).indexOf(filter.value.toString().toLowerCase()) > -1 : true
            )
        }
    }
    else if (row[id] !== null && typeof row[id] === 'boolean') {
        if(
            (filter.value.toLowerCase() === "ativo" || filter.value.toLowerCase() === "bloqueado")
            && row[id] === true
        ){
            return true;
        }
        else if(
            (filter.value
                .toLowerCase() === "inativo" || filter.value.toLowerCase() === "liberado")
            && row[id] === false
        ){
            return true;
        }
        else{
            return false;
        }
    }
    else {
        return (
            String(row[filter.id]) === filter.value
        )
    }
}

function FormataStringData(data) {
    var dia, mes, ano;
    if (data.split("-").length == 2)
    {
        dia  = data.split("-")[2].substring(0,2);
        mes  = data.split("-")[1];
        ano  = data.split("-")[0];
    }
    else if (data.split("/").length == 2){
        dia  = data.split("/")[2].substring(0,2);
        mes  = data.split("/")[1];
        ano  = data.split("/")[0];
    }

    var result;
    if (dia != null)    
        result = dia + "/" + mes + "/" + ano;

    var hora, minuto, segundo;
    if (data.split("t").length == 2)
    {
        hora  = data.split("t")[1].split(":")[0];
        minuto  = data.split("t")[1].split(":")[1];
        segundo  = data.split("t")[1].split(":")[2].substring(0,2);

        result += " " + hora + ":" + minuto + ":" + segundo;
    }    
  
    return result;
  }

export {
    medeString,
    noCaseSensitive
}